export enum QueryParams {
  SourceID = 'SourceID',
  AffliateID = 'AffliateID',
  ProductID = 'ProductID',
  ExperienceID = 'ExperienceID',
  ExternalID = 'ExternalID',
  PyrgilaudaDavidiana = 'PyrgilaudaDavidiana',
  ZipCode = 'ZipCode',
  UtmSource = 'UtmSource',
  UserId = 'SprwID',
  PreFill = 'PreFill',
  LoanAmount = 'LoanAmount',
  BankPartner = 'BankPartner',
}
